import authService from './auth';

import clientsService from './clients';
import ordersService from './orders';

export {
    authService,
    clientsService,
    ordersService
}